import React, {useState, useEffect, useRef, useContext} from 'react';
import { useTranslation } from "react-i18next";

import { useSelector } from 'react-redux';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { TabMenu } from 'primereact/tabmenu';
import { AuthContext } from "../../../../Header/auth - context";
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog'; // <- mora biti renderovana
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import CustomDropdown from '../../../../custom/customDropdown';
import { Tooltip } from 'primereact/tooltip';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import '../../magacin_basic.css';

const Unos_artikla_konfig = (props) => {
  const { t } = useTranslation();

        const toast = useRef(null);
        const formRef = useRef(null);
        const auth = useContext(AuthContext);
        const company = useSelector(state => state.company)
        const user = useSelector(state => state.user)
        const [selectedRowIdItem , setSelectedRowIdItem] = useState(null);
        const isSelected = (row) => String(getIdItem(row)) === String(selectedRowIdItem);
        const [jedinicaMereOptions, setJedinicaMereOptions] = useState([])
        /* Valute i podrazumevana valuta firme stizu uz podatke magacina. */
        const [valutaOptions, setValutaOptions] = useState([])
        const [valutaFirme, setValutaFirme] = useState(null)
        const [izabran, setIzabran] = useState(false)
        const [idItem, setIdItem] = useState(null)
        const [popuni, setPopuni] = useState(false)
        const [globalFilter, setGlobalFilter] = useState(null);
        const [first, setFirst] = useState(0);
        const [tableData, setTableData] = useState(null);
        const [allColumns, setAllColumns] = useState([]);
        const [selectedColumns, setSelectedColumns] = useState([]);
        const [originalColumnOrder, setOriginalColumnOrder] = useState([]);
        const [porukaTimeRange, setPorukeTimeRange] = useState(null)
        const [formSubmitted, setFormSubmitted] = useState(false);
        const getIdItem = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null;
        ///DATA

         const [formData, setFormData] = useState({
        SifraStavke: null,
        NazivArtikla: null,
        JedinicaMere: null,
        Neto: null,
        Bruto: null,
        Guma: false,
        Cena: null,
        Valuta: null,
        Napomena: ''
        });

        /* Istorija cena — ucitava se tek kad je operater zatrazi. */
        const [istorijaCena, setIstorijaCena] = useState([]);
        const [istorijaVidljiva, setIstorijaVidljiva] = useState(false);

    const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

    const popuniRedove = async (id) => {
  
        if(!id) {
             toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste izabrali karticu da bi popunili podatke!",
                        life: 3000,
                    });
        } else {
              let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id,
                                firma_id: company.companyId,
                                user_id: user.userId
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/GetWarehouseArtical", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  
                               
                                popuniStavke(data)
                                
                               toast.current.show({
                                severity: "success",
                                summary: "Uspešno popunjavanje podataka artikla!",
                                life: 3000,
                                });
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
        }
          
    }

  const popuniStavke = (apiData) => {

    setFormData({
        SifraStavke: apiData[0].id || null,
        NazivArtikla: apiData[0].NazivArtikla || '',
        JedinicaMere: apiData[0].JedinicaMere || null,
        Neto: apiData[0].Neto || null,
        Bruto: apiData[0].Bruto || null,
        Guma: apiData[0].Guma || false,
        Cena: apiData[0].Cena != null ? Number(apiData[0].Cena) : null,
        Valuta: apiData[0].Valuta != null ? Number(apiData[0].Valuta) : null,
        Napomena: apiData[0].Napomena || ''
      });
};

   useEffect(()=>{
    if(!formSubmitted){
                   let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  firma_id: company.companyId,
                                  user_id: user.userId
                              }),
                          };
                          fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/GetWarehouseAndTypes", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                                
                                const stringifiedJson = data[0][""];
                                const parsedData = JSON.parse(stringifiedJson);

                                setTableData(parsedData.ArticalDB)
                                setJedinicaMereOptions(parsedData.JediniceMereDB)
                                setValutaOptions(parsedData.ValuteDB || [])
                                setValutaFirme(parsedData.ValutaFirme ?? null)


                                 if (parsedData.ArticalDB && parsedData.ArticalDB.length > 0) {
                                                const columns = Object.keys(parsedData.ArticalDB[0])
                                                    .filter(key => !['ID'].includes(key))
                                                    .map(key => ({
                                                    label: key,
                                                    value: key
                                                    }));
                                        
                                                 
                                                setAllColumns(columns);
                                                const originalOrder = Object.keys(parsedData.ArticalDB[0]);
                                                setOriginalColumnOrder(originalOrder);
                                                
                                                // Select first 5 columns by default (or adjust as needed)
                                                setSelectedColumns(columns.slice(0, 10).map(col => col.value));
                                                }
                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                              
    }
      },[formSubmitted])



const resetData = ()=> {
        setFormData({
        SifraStavke: '',
        NazivArtikla: '',
        JedinicaMere: null,
        Neto: null,
        Bruto: null,
        Guma: false,
        Cena: null,
        Valuta: null,
        Napomena: ''
        });
        setIstorijaCena([]);
}
/* Istorija cena jednog artikla. Cita se iz baze pri svakom otvaranju — cena
   se moze promeniti sa otpremnice u drugoj kartici. */
const prikaziIstorijuCena = async () => {
    if (!idItem) {
        toast.current.show({
            severity: 'warn', summary: t('common.upozorenje'),
            detail: t('magacin.istorijaCenaIzaberi'), life: 3000,
        });
        return;
    }

    try {
        const odgovor = await fetch(process.env.REACT_APP_BACKEND_URL + '/warehouse/GetArtikalCene', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
            body: JSON.stringify({ id: Number(idItem) }),
        });
        const podaci = await odgovor.json();
        setIstorijaCena(Array.isArray(podaci) ? podaci : []);
        setIstorijaVidljiva(true);
    } catch (e) {
        toast.current.show({
            severity: 'error', summary: 'Error', detail: String(e?.message || e), life: 3000,
        });
    }
};

const handleDeleteFuncRelease = () => {
       
            confirmDialog({
            message: "Želite pasivizirati artikal?",
            acceptLabel: "Da",
            rejectLabel: "Ne",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: acceptDelete,
            reject: rejectDelete,
            });

    };

    const acceptDelete = async () => {
 
  if (idItem) {
    setFormSubmitted(true)
     let requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
          body: JSON.stringify({
            id: idItem
          }),
        };
        
        fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/DeleteWarehouseArtical", requestOptions)
          .then(handleErrors)
          .then((data) => {
            
             toast.current.show({
                severity: "success",
                summary: "Uspešno pasiviziranje artikla!",
                life: 3000,
                });
                resetData()
                setIdItem(null)
                setFormSubmitted(false)
                props.setChangeArtical(false);
                setSelectedRowIdItem(null)
          })
          .catch((error) => {
            error.json().then((errorMessage) => {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: errorMessage.message,
                life: 3000,
              });
              console.log(errorMessage);
            });
          });
  } else {
        toast.current.show({
            severity: "warn",
            summary: "Niste izabrali artikal za brisanje!",
            life: 3000,
            });
  }
   

  };
  const rejectDelete = () => {
    console.log("Odbijeno brisanje podataka!");
  }; 
  
  function toUtcIso(d) {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
    return utc.toISOString().slice(0, 19) + 'Z';
    }

   const handleFormSubmit = (e) => {
  
                       e.preventDefault(); // bitno da ne submituje bez validacije
                  setFormSubmitted(true)
              if (formRef.current && !formRef.current.checkValidity()) {
                  formRef.current.reportValidity(); // prikazuje native browser poruke
                  return;
              }
      handleUploadAndSave()
   }
          const handleUploadAndSave = () => {
         
              confirmDialog({
              message: "Jel ste sigurni da želite nastaviti sa unosom?",
              acceptLabel: "Da",
              rejectLabel: "Ne",
              icon: "pi pi-info-circle",
              acceptClassName: "p-button-danger",
              accept: acceptInsert,
              reject: rejectInsert,
              });
          
  
      };

      const acceptInsert = async () => {
  
              //DATA
                  const hasAnyValue = Object.values(formData).some(value => {
                  if (value === null || value === '') return false;
  
                  // Check if it's a valid Date object
                  if (value instanceof Date && isNaN(value.getTime())) return false;
  
                  return true;
                  });
                  const payload = {
                        ...formData
                        };

                  if(izabran && idItem){
                 if(hasAnyValue){                        
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: Number(idItem),
                                firma_id: company.companyId,
                                user_id: user.userId,
                                formData: payload
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/UpdateWarehouseArtical", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                             
                               if(data){
                                    if(data[0].message && data[0].message != 'Nema izmena u podacima artikla.' && data[0].message != 'Nedostaje id za UPDATE.' 
                                        && data[0].message != 'Zapis nije pronađen ili nije aktivan.' && data[0].message != 'Izmena nije moguća: postoji drugi aktivan artikal sa ovim nazivom.'){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data[0].message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                if(data[0].message){
                                toast.current.show({
                                severity: "warn",
                                summary: data[0].message,
                                life: 3000,
                                });
                                return
                               }

                                toast.current.show({
                                severity: "success",
                                summary: "Uspešna izmena podataka artikla!",
                                life: 3000,
                                });
                           
                                setFormSubmitted(false);
                                props.setChangeArtical(false);
                                setIdItem(null)
                                setSelectedRowIdItem(null)
                                setIzabran(false)
                                resetData()
                                } 
                                
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste popunili podatke artikla!",
                        life: 3000,
                    });
                }
           
           
                } else {
                  if(hasAnyValue){
                      
                            let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  firma_id: company.companyId,
                                  user_id: user.userId,
                                  formData: payload
                              }),
                          };
                          
                          await fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/InsertWarehouseArtical", requestOptions)
                              .then(handleErrors)
                              .then((data) => {

                                  if(data.message) {
                                        if(data.message != 'Artikal sa istim nazivom već postoji.' && data.message != 'Uspešan unos artikla!'){
                                        toast.current.show({
                                        severity: "error",
                                        summary: "Error",
                                        detail: data.message,
                                        life: 3000,
                                        });
                                        return
                                        } 
                                  }
                                  
                                  resetData()
                                  setFormSubmitted(false)
                                  props.setChangeArtical(false);
                                 toast.current.show({
                                  severity: "success",
                                  summary: "Uspešan unos podataka artikla!",
                                  life: 3000,
                                  });

                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                  } else {
                          toast.current.show({
                          severity: "warn",
                          summary: "Upozorenje!",
                          detail: "Niste popunili podatke artikla za unos!",
                          life: 3000,
                      });
                  }
            }
  
    };
      const rejectInsert = () => {
      console.log("Odbijen unos podataka!");
    };     
  
    const handleChange = (e) => {
        const { name, value, checked } = e.target;

        if (name in formData) {
            if (name === 'Guma') {
                setFormData(prev => ({ ...prev, [name]: checked }));
            } else {
                setFormData(prev => ({ ...prev, [name]: value }));
            }
        }
    };
  
  
  const invalidControl = (data) => {
    if (!formSubmitted) return false; // ← NE prikazuj grešku dok forma nije poslata
  
    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };


  const exportExcel = async () => {
      if (!selectedColumns || selectedColumns.length === 0) return;
  
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Oslobađajući tekst');
  
      const headers = selectedColumns;

      const headerRow = worksheet.addRow(headers);
      headerRow.font = { bold: true };
      headerRow.eachCell((cell) => {
          cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFEFEFEF' }
          };
          cell.border = {
              top: { style: 'medium' },
              left: { style: 'medium' },
              bottom: { style: 'medium' },
              right: { style: 'medium' }
          };
      });
  
      tableData.forEach((rowData) => {
          const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
          row.eachCell((cell) => {
              cell.border = {
                  top: { style: 'thin' },
                  left: { style: 'thin' },
                  bottom: { style: 'thin' },
                  right: { style: 'thin' }
              };
          });
      });
  
      worksheet.columns.forEach((column, i) => {
          const lengths = [
              headers[i].length,
              ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
          ];
          column.width = Math.max(...lengths) + 2;
      });
  
      const date = new Date();
      const options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Europe/Belgrade'
      };
      const serbianDateTime = date.toLocaleString('sr-RS', options)
          .replace(/\s/g, ' ')
          .replace(/,/g, '');
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `Oslobađajući tekst - ${company.companyName} - ${serbianDateTime}.xlsx`);
  };
       const header = (
          <div className="export-buttons fakture-stavke-header">
              <div className="fakture-stavke-radnje">              
              <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
              {selectedRowIdItem && <Button type="button" style={{marginLeft:'5px'}} icon="pi pi-trash" severity="danger" rounded onClick={handleDeleteFuncRelease} data-pr-tooltip="Print" />}             
              </div>
                                                             <input
                                                style={{width:'100%', maxWidth:'50%'}}
                                                type="search"
                                                onInput={(e) => setGlobalFilter(e.target.value.replace(/\s+/g, ' ').trimStart())}
                                                placeholder={t('nova.phPretraga')}
                                                className="p-inputtext p-component"
                                              />
          </div>
      );

     const isButtonColumn = (field) => {
    return field.startsWith('Izaberi') || 
           field.includes('File') || 
           field.includes('fajl') || 
           field.includes('upload') ||
           field.endsWith('LK') || // Lična karta
           field.endsWith('VD') || // Vozačka dozvola
           field.endsWith('PASS') || // Pasoš
           field.endsWith('VIZA') || // Viza
           field.includes('Dokument'); // Generic document
  };

    const chooseItem = (rowData) => {
        const id = getIdItem(rowData);

        setSelectedRowIdItem((prev) => {
        const next = String(prev) === String(id) ? null : String(id);

        if(next) {
        setIdItem(next)
        popuniRedove(id)
        setIzabran(true) 
        }
        else {
        setIdItem(null)
        resetData()
        setIzabran(false) 
        }

        return next;
    });
    }

     const previewBodyTemplate = (rowData, field) => {
      const filePathsString = rowData[field];
      if (!filePathsString) return '-';
     
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <Button
                label='Izaberi'
                icon="pi pi-eye"
                type="button"
                className="p-button-text p-button-sm"
                onClick={(e) => chooseItem(rowData)}
              />
            
        </div>
      );
    };

   return (
       <div style={{marginTop:"1%"}}> 
        <Toast ref={toast} />        

            <div className='col-12'>
                          <div className='blagajnaDashboard dnevniceDashboard artikli-radni-prostor'>
                             <Card>
                            <form autoComplete="off" ref={formRef} style={{marginTop:'1%'}}>
                            <div className="artikli-forma-grid">
                               <div className="artikal-polje artikal-polje--puno">
                                    <label htmlFor="NazivArtikla">{t('magacin.nazivArtikla')}:</label>
                                    <InputText
                                    id="NazivArtikla"
                                    name="NazivArtikla"
                                    value={formData.NazivArtikla}
                                    required
                                    invalid={invalidControl(formData.NazivArtikla)}
                                    onChange={handleChange} />
                                </div>

                                <div className="artikal-polje">
                                    <label htmlFor="SifraStavke">{t('magacin.sifraArtikla')}:</label>
                                    <InputText
                                    id="SifraStavke"
                                    name="SifraStavke"
                                    value={formData.SifraStavke}
                                    disabled
                                    onChange={handleChange}
                                    type='number' />
                                </div>

                                <div className="artikal-polje">
                                  <label htmlFor="JedinicaMere">{t('nova.jedinicaMere')}:</label>
                                  <CustomDropdown
                                      options={jedinicaMereOptions || []}
                                      value={formData.JedinicaMere}
                                      placeholder={t('nova.jedinicaMere')}
                                      optionLabel="label"
                                      id="JedinicaMere"
                                      name="JedinicaMere"
                                      onChange={handleChange}
                                      style={{width:'100%'}}
                                      required
                                      invalid={invalidControl(formData.JedinicaMere)}/>
                                </div>

                                <div className="artikal-polje">
                                  <label htmlFor="Neto">{t('magacin.netoTezina')}:</label>
                                  <InputNumber
                                    id="Neto"
                                    name="Neto"
                                    value={formData.Neto}
                                    onValueChange={handleChange}
                                    minFractionDigits={2}
                                    maxFractionDigits={2}
                                  />
                                </div>

                                <div className="artikal-polje">
                                  <label htmlFor="Bruto">{t('magacin.brutoTezina')}:</label>
                                  <InputNumber
                                    id="Bruto"
                                    name="Bruto"
                                    value={formData.Bruto}
                                    onValueChange={handleChange}
                                    minFractionDigits={2}
                                    maxFractionDigits={2}
                                  />
                                </div>

                                {/* Sve sto se tice cene u jednom okviru — cena i valuta se
                                    citaju zajedno, a istorija je njihov trag. */}
                                <div className="cena-okvir">
                                  <span className="cena-okvir-naslov">{t('magacin.cena')}</span>

                                  <div className="artikal-polje">
                                    <label htmlFor="Valuta">{t('magacin.valuta')}:</label>
                                    <CustomDropdown
                                      id="Valuta"
                                      name="Valuta"
                                      optionLabel="label"
                                      value={formData.Valuta ?? valutaFirme}
                                      options={valutaOptions}
                                      onChange={handleChange}
                                      style={{width:'100%'}}
                                    />
                                  </div>

                                  <div className="artikal-polje cena-iznos">
                                    <label htmlFor="Cena">{t('magacin.cenaNeto')}:</label>
                                    <InputNumber
                                      id="Cena"
                                      name="Cena"
                                      value={formData.Cena}
                                      onValueChange={handleChange}
                                      min={0}
                                      minFractionDigits={2}
                                      maxFractionDigits={2}
                                    />
                                  </div>

                                  {izabran && idItem && (
                                    <div className="cena-akcije">
                                      <Button
                                        type="button"
                                        icon="pi pi-history"
                                        label={t('magacin.istorijaCena')}
                                        className="p-button-text p-button-sm"
                                        onClick={prikaziIstorijuCena}
                                      />
                                    </div>
                                  )}
                                </div>

                                <div className="artikal-polje artikal-polje--prekidac">
                                  <Checkbox
                                    inputId="Guma"
                                    name="Guma"
                                    checked={formData.Guma}
                                    onChange={handleChange}
                                  />
                                  <label htmlFor="Guma">{t('magacin.pneumatikGuma')}</label>
                                </div>

                                <div className="artikal-polje artikal-polje--puno">
                                  <label htmlFor="Napomena">{t('nova.napomena')}:</label>
                                  <InputTextarea
                                      variant="filled"
                                      id="Napomena"
                                      name="Napomena"
                                      value={formData.Napomena}
                                      onChange={handleChange}
                                      rows={4} />
                                </div>
                            </div>
                            <div className="formUnosZap buttonUnosZap">
                            <button type="submit" onClick={handleFormSubmit} style={{minWidth:"fit-content", marginTop:'2%'}} className="btn btn-success">
                                {izabran ? "SAČUVAJ" : "UNOS"}
                            </button>
                            </div>
                            </form>
                          </Card>
                          <Card>
                               <Tooltip target=".export-buttons>button" position="bottom" />
                                   <DataTable
                                          value={tableData || []}
                                          paginator
                                          rows={10}
                                          first={first}
                                          globalFilter={globalFilter}
                                          onPage={(e) => setFirst(e.first)}
                                          scrollable
                                          header={header}
                                          scrollHeight="clamp(260px, 52vh, 620px)"
                                          emptyMessage={t('common.noDataTable')}
                                          resizableColumns
                                          className="turePregledTable stavke-tabela"
                                          columnResizeMode="expand"
                                          rowClassName={(data) => (isSelected(data) ? "selected-row" : "")}
                                        >
                                          {selectedColumns.map((colKey) => {
                                          const colMeta = allColumns.find(col => col.value === colKey);
                                          return (
                                            <Column
                                              key={colKey}
                                              field={colKey}
                                              header={colMeta?.label || colKey}
                                              sortable
                                              body={(rowData) => {
                                                if (isButtonColumn(colKey)) {
                                                  return previewBodyTemplate(rowData, colKey);
                                                }
                                                return rowData[colKey] || '-';
                                              }}
                                              style={{ minWidth: '150px'}}
                                            />
                                          );
                                        })}
                                    </DataTable>
                          </Card>
                          </div>
            </div>                                

    <Dialog
      header={t('magacin.istorijaCena') + (formData.NazivArtikla ? ' — ' + formData.NazivArtikla : '')}
      visible={istorijaVidljiva}
      onHide={() => setIstorijaVidljiva(false)}
      style={{ width: '55vw' }}
      breakpoints={{ '960px': '85vw', '640px': '95vw' }}
    >
      <DataTable value={istorijaCena} paginator rows={10}
        emptyMessage={t('magacin.istorijaCenaPrazna')}
        className="stavke-tabela">
        <Column field="Datum" header={t('nova.datum')} />
        <Column field="Cena" header={t('magacin.cena')} />
        <Column field="Prethodna cena" header={t('magacin.cenaPrethodna')} />
        <Column field="Otpremnica" header={t('magacin.otpremnica')} />
        <Column field="Korisnik" header={t('magacin.korisnik')} />
      </DataTable>
    </Dialog>
       </div>
)
}

export default Unos_artikla_konfig;